import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-support-settings-quick-action',
  templateUrl: './support-settings-quick-action.component.html',
  styles: [
  ],
})
export class SupportSettingsQuickActionComponent implements OnInit {

  @Input() settings: any = {};


  supportSettingsData: any = {

    autoAssignment: false,

    slaEnabled: false,

    firstResponseHours: 4,

    resolutionHours: 24,

    emailNotification: true,

    customerNotification: true,

    agentNotification: true,

    allowCustomerReopen: true

  };


  constructor(
    public activeModal: NgbActiveModal
  ) {}


  ngOnInit(): void {

    if (this.settings) {

      this.supportSettingsData = {

        ...this.supportSettingsData,

        ...this.settings

      };

    }

  }


  // =====================================================
  // CLOSE
  // =====================================================

  close(): void {

    this.activeModal.dismiss();

  }


  // =====================================================
  // SAVE
  // =====================================================

  saveSettings(): void {

    this.activeModal.close({

      success: true,

      settings:
        this.supportSettingsData

    });

  }

}
